// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"163":"c403aa8a","481":"1022dd51","498":"30325125","991":"e57df286"}[chunkId] + ".chunk.js";
};